import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenField", "customInput", "nativeInput", "errorMessage"]
  
  static values = {
    selected: String
  }

  connect() {
  }

  // Action déclenchée par le clic sur une couleur de palette
  selectColor(event) {
    const color = event.currentTarget.dataset.colorPickerColorParam
    this.setColor(color)
    this.updateSelectedButton(event.currentTarget)
  }

  // Action déclenchée par la saisie dans le champ texte
  validateCustomColor(event) {
    const color = event.currentTarget.value
    
    if (this.isValidHexColor(color)) {
      this.setColor(color)
      this.hideError()
      this.updateSelectedButton(null) // Désélectionner les boutons de palette
    } else if (color.length > 0) {
      this.showError("Format invalide. Utilisez #ffffff")
    } else {
      this.hideError()
    }
  }

  // Action déclenchée par le color picker natif HTML5
  handleNativeInput(event) {
    const color = event.currentTarget.value
    this.setColor(color)
    this.customInputTarget.value = color
    this.updateSelectedButton(null)
    this.hideError()
  }

  // Méthode centrale pour définir la couleur
  setColor(color) {
    this.selectedValue = color
    this.hiddenFieldTarget.value = color
    this.customInputTarget.value = color
    this.nativeInputTarget.value = color
  }


  // Mettre à jour le bouton sélectionné dans la palette
  updateSelectedButton(selectedButton) {
    // Retirer la sélection de tous les boutons
    const allButtons = this.element.querySelectorAll('.color-button')
    allButtons.forEach(button => {
      button.classList.remove('border-gray-700', 'ring-2', 'ring-gray-400')
      button.classList.add('border-gray-300')
    })
    
    // Ajouter la sélection au bouton cliqué
    if (selectedButton) {
      selectedButton.classList.remove('border-gray-300')
      selectedButton.classList.add('border-gray-700', 'ring-2', 'ring-gray-400')
    }
  }

  // Validation du format couleur hexadécimal
  isValidHexColor(color) {
    return /^#[0-9A-Fa-f]{6}$/.test(color)
  }

  // Afficher un message d'erreur
  showError(message) {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = message
      this.errorMessageTarget.classList.remove('hidden')
    }
  }

  // Masquer le message d'erreur
  hideError() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.classList.add('hidden')
    }
  }

  // Calculer une couleur plus foncée (pour le progress dans WaveSurfer)
  getDarkerColor(color) {
    // Convertir hex en RGB
    const hex = color.replace('#', '')
    const r = parseInt(hex.substr(0, 2), 16)
    const g = parseInt(hex.substr(2, 2), 16)
    const b = parseInt(hex.substr(4, 2), 16)
    
    // Assombrir de 20%
    const darkerR = Math.floor(r * 0.8)
    const darkerG = Math.floor(g * 0.8)
    const darkerB = Math.floor(b * 0.8)
    
    // Reconvertir en hex
    return `#${darkerR.toString(16).padStart(2, '0')}${darkerG.toString(16).padStart(2, '0')}${darkerB.toString(16).padStart(2, '0')}`
  }

  // Calculer la luminance d'une couleur (pour contraste)
  getLuminance(color) {
    const hex = color.replace('#', '')
    const r = parseInt(hex.substr(0, 2), 16) / 255
    const g = parseInt(hex.substr(2, 2), 16) / 255
    const b = parseInt(hex.substr(4, 2), 16) / 255
    
    return 0.299 * r + 0.587 * g + 0.114 * b
  }
}